import ApproverApi from "../generated/api/ApproverApi";
import SaveApproverRequest from "../generated/model/SaveApproverRequest";
import EnvService from "../env.settings.js";

class ApproverService {
  constructor() {
    this.ApproverApi = new ApproverApi();
  }

  async All(nameFilter, emailFilter) {
    const opts = {};
    if (nameFilter) opts.nameFilter = nameFilter;
    if (emailFilter) opts.emailFilter = emailFilter;
    return await window.$A.HandleApiResponse(
      this.ApproverApi.getAll(opts)
    );
  }
  async AllIndexed() {
    return await window.$A.HandleApiResponse(
      this.ApproverApi.getAllIndexed()
    );
  }

  async GetWithStats(approverId) {
    return await window.$A.HandleApiResponse(
      this.ApproverApi.getApproverWithStats(approverId)
    );
  }

  // Raw fetch of /approver/{id}/with-stats so new stat fields aren't dropped
  // by the generated ApproverWithStats model.
  async GetWithStatsRaw(approverId) {
    const baseUrl = EnvService.instance.apiHost.replace(/\/+$/, "");
    const token = window.$A && window.$A.Auth && window.$A.Auth.apiToken
      ? window.$A.Auth.apiToken.token
      : "";
    const res = await fetch(`${baseUrl}/approver/${approverId}/with-stats`, {
      headers: { AccessToken: token },
    });
    if (!res.ok) return null;
    try { return await res.json(); } catch (_e) { return null; }
  }

  async Save(approver) {
    if (approver.name.length < 3 || !window.$A.IsEmailValid(approver.email)) {
      window.$A.AlertUser("Please Fill Out The Approver Form Before Saving");
      return;
    }

    let obj = SaveApproverRequest.constructFromObject({
      name: approver.name,
      email: approver.email,
      phone: approver.phone,
      frequency: approver.frequency,
      timeOfDayToSend: approver.timeOfDayToSend,
      timeZone: approver.timeZone,
      utcOffsetMin: approver.utcOffsetMin,
    });

    if (approver.id !== undefined && approver.id > 0) {
      return await window.$A.HandleApiResponse(
        this.ApproverApi.updateApprover(approver.id, {
          saveApproverRequest: obj,
        }),
        "Contact Updated"
      );
    } else {
      return await window.$A.HandleApiResponse(
        this.ApproverApi.createApprover({
          saveApproverRequest: obj,
        }),
        "Contact Updated"
      );
    }
  }

  async DeleteSingle(id) {
    return await window.$A.HandleApiResponse(
      this.ApproverApi.deleteApprover(id),
      "Contact Deleted"
    );
  }

  async Delete(ids) {
    window.$A.ApiWorking();
    let allPromises = [];
    for (const approverIdToDelete of ids) {
      allPromises.push(this.ApproverApi.deleteApprover(approverIdToDelete));
    }
    try {
      const results = await Promise.all(allPromises);
      window.$A.AlertUser("Contact Deleted", "success");
      return results;
    } catch (err) {
      window.$A.AlertUser(
        "Unable to delete contact. Please try again or contact support.",
        "warning"
      );
      return null;
    } finally {
      window.$A.ApiIdle();
    }
  }
}

export default ApproverService;
